// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { type SegmentMatrix } from '@shared/data-access/interfaces/api/ai/portfolio-analysis';
import { numberToFixed } from '@shared/ui-kit/utils';

interface DataPoint {
  id: string;
  data: { x: string; y: number }[];
}

export const transformMatrixData = (input: SegmentMatrix): DataPoint[] => {
  const dataPoints: DataPoint[] = [];
  const { style, size, weight } = input;

  const names: { [key: string]: string } = {
    Val: 'Value',
    Bld: 'Mixed',
    Gwth: 'Growth',
    large: 'Large',
    mid: 'Medium',
    small: 'Small',
  };

  const uniqueSizes = Array.from(new Set(size));

  uniqueSizes.forEach(size => {
    const dataPoint: DataPoint = {
      id: names[size.toLowerCase() as keyof typeof names],
      data: [],
    };

    style.forEach((styleValue, index) => {
      if (size === input.size[index]) {
        dataPoint.data.push({
          x: names[styleValue as keyof typeof names],
          y: numberToFixed(weight[index] * 100, 1),
        });
      }
    });

    dataPoints.push(dataPoint);
  });

  return dataPoints;
};
